// extracted by mini-css-extract-plugin
export var quillEditor = "_nw-1";
export var variable = "_nw-0";